import { useEffect } from 'react';

import { largeScreenQuery } from './largeScreenQuery';
import { useSidebarMode } from './useSidebarMode';

export function useSidebarDocker() {
  const [, setSidebarMode] = useSidebarMode();

  useEffect(() => {
    const handleMatchChange = ({ matches }: { matches: boolean }) => {
      setSidebarMode(matches ? 'docked' : 'collapsed');
    };

    // Set initial sidebar mode
    handleMatchChange({ matches: largeScreenQuery.matches });

    // Set up change handler to update sidebar mode across the lg breakpoint
    largeScreenQuery.addEventListener('change', handleMatchChange);

    return () => {
      largeScreenQuery.removeEventListener('change', handleMatchChange);
    };
  }, [setSidebarMode]);
}
